import api from '../../../../App/socket';

export const changeUserAddress = (country, city, street, zip_code, state, user_id, address_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedUpdate',
        options: {
            where: {
                _id: user_id,
            },
            fullPath: `person.addresses.${address_id}`,
            update: {
                country, city, street, zip_code, state,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_addresses_requests/change_user_addresses_request.js